import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route } from 'react-router-dom';

import { MainPage } from './pages/Main.page';
import { AuthLayouts } from './authLayouts/AuthLayouts.component';
import { Login } from './authLayouts/Login.page';
import { ForgotYourPassword } from './authLayouts/ForgotYourPassword.page';
import { ResetPassword } from './authLayouts/ResetPassword.page';
import { RequireAuth } from './authLayouts/RequireAuth.component';

import { Users } from './pages/Users.page';
import { UserEdit } from './pages/UserEdit.page';
import { Prices } from './pages/Prices.page';
import { Tariffs } from './pages/Tariffs.page';
import { TariffPlanUpsert } from './pages/TariffPlanUpsert.page';
import { Senders } from './pages/Sender.page';
import { SenderUpsert } from './pages/SenderUpsert.page';
import { Payments } from './pages/Payments.page';
import { PaymentUpsert } from './pages/PaymentUpsert.page';
import { TariffPlan } from './pages/TariffPlan.page';
import { TariffPlanAssign } from './pages/TariffPlanAssign.page';
import { PersonalizedPricing } from './pages/PersonalizedPricing.page';
import { CustomPriceUpsert } from './pages/CustomPriceUpsert.page';
import { PersonalizedSender } from './pages/PersonalizedSender.page';
import { CustomSenderUpsert } from './pages/CustomSenderUpsert.page';
import { AdminUsers } from './pages/AdminUser.page';
import { AdminUserUpsert } from './pages/AdminUserUpsert.page';

const App = () => {

  return (
    <div className="App">
      <Routes>
        <Route path='*' element={<AuthLayouts />}>
          <Route path="log-in" element={<Login />} />
          <Route path="forgot-password" element={<ForgotYourPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
        </Route>

        <Route path='/' element={<RequireAuth><MainPage /></RequireAuth>}>
          <Route index element={<Users />} />
          <Route path='users' element={<Users />} />
          <Route path='users/user-edit/:id' element={<UserEdit />} />
          <Route path='prices' element={<Prices />} />
          <Route path='tariffs' element={<Tariffs />} />
          <Route path='add-tariff-plan' element={<TariffPlanUpsert />} />
          <Route path='senders' element={<Senders />} />
          <Route path='create-sender' element={<SenderUpsert />} />
          <Route path='senders/:id' element={<SenderUpsert edit />} />
          <Route path='payment' element={<Payments />} />
          <Route path='add-payment' element={<PaymentUpsert />} />
          <Route path='payment/:id' element={<PaymentUpsert edit />} />
          <Route path='tariff-plan' element={<TariffPlan />} />
          <Route path='assign-tariff-plan' element={<TariffPlanAssign />} />
          <Route path='custom-prices' element={<PersonalizedPricing />} />
          <Route path='custom-prices/:id' element={<CustomPriceUpsert edit />} />
          <Route path='upload-custom-price' element={<CustomPriceUpsert />} />
          <Route path='custom-senders' element={<PersonalizedSender />} />
          <Route path='custom-senders/:id' element={<CustomSenderUpsert edit />} />
          <Route path='custom-sender-create' element={<CustomSenderUpsert />} />
          <Route path='admin-users' element={<AdminUsers />} />
          <Route path='add-admin-user' element={<AdminUserUpsert />} />
          <Route path='admin-users/admin-user-edit/:id' element={<AdminUserUpsert edit />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
